//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import userChecks from '~/mixins/userChecks';
export default {
  mixins: [userChecks],
  async fetch() {
    let query = {
      slug: this.$route.params.slug,
      query: this.queries.show
    };
    await Promise.all([ 
     this.$store.dispatch('resourcesStore/getResource', query),
     this.$store.dispatch('bannerStore/getBanner', 'resource'),
     this.$store.dispatch('resourcesStore/countResource', {
      id: this.$route.params.slug
    })
   ])
  },
  head() {
    return {
      title:
      this.show && this.show.seo && this.show.seo
      ? this.show.seo.title
      : 'Series | Meiden van Holland',
      meta: [
        {
          hid: 'title',
          name: 'title',
          content:
          this.show && this.show.seo && this.show.seo
          ? this.show.seo.title
          : 'Series | Meiden van Holland',
        },
        {
          hid: 'og:title',
          name: 'og:title',
          content:
          this.show && this.show.seo && this.show.seo
          ? this.show.seo.title
          : 'Series | Meiden van Holland',
        },
        {
          hid: 'twitter:title',
          name: 'twitter:title',
          content:
          this.show && this.show.seo && this.show.seo
          ? this.show.seo.title
          : 'Series | Meiden van Holland',
        },
        {
          hid: 'description',
          name: 'description',
          content:
          this.show && this.show.seo && this.show.seo
          ? this.show.seo.description
          : 'Geil Series van Meiden van Holland en al de lekkere sexfilms',
        },
        {
          hid: 'og:description',
          name: 'og:description',
          content:
          this.show && this.show.seo && this.show.seo
          ? this.show.seo.description
          : 'Geil Series van Meiden van Holland en al de lekkere sexfilms',
        },
        {
          hid: 'twitter:description',
          name: 'twitter:description',
          content:
          this.show && this.show.seo && this.show.seo
          ? this.show.seo.description
          : 'Geil Series van Meiden van Holland en al de lekkere sexfilms',
        },
        {
          hid: 'og:url',
          name: 'og:url',
          content:
          this.show && this.show.slug
          ? 'https://meidenvanholland.nl/series/' + this.show.slug
          : 'https://meidenvanholland.nl/showlen/',
        },
        {
          hid: 'twitter:url',
          name: 'twitter:url',
          content:
          this.show && this.show.slug
          ? 'https://meidenvanholland.nl/series/' + this.show.slug
          : 'https://meidenvanholland.nl/series/',
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content:
          this.show && this.show.seo && this.show.seo
          ? this.show.seo.keywords
          : 'series, sexshow, pornoster, Meiden van Holland',
        },
        {
          hid: 'og:image',
          name: 'og:image',
          content:
          this.show && this.show.thumb
          ? process.env.CDN + this.show.thumb.l
          : '',
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          content:
          this.show && this.show.thumb
          ? process.env.CDN + this.show.thumb.l
          : '',
        },
        {
          hid: 'twitter:card',
          name: 'twitter:card',
          content: 'summary_large_image',
        },
      ],
    };
  },
  components: {
    dummy: () => import('~/components/content/dummy/resource_dummy.vue'),
    thumb: () => import('~/components/thumb'),
    breadcrumbs: () => import('~/components/breadcrumbs'),
    Description: () => import('~/components/DescriptionResources.vue'),
    Readmore: () => import('~/components/Readmore.vue'),
    favorite: () => import('~/components/FavoriteResources'),
    IncludedVideos: () => import('~/components/IncludedVideos.vue'),
    banner: () => import('~/components/banner.vue'),
    error: () => import('~/components/error.vue')
  },
  computed: {
    ...mapState({
      queries: ({ resourcesStore: {queries} }) => queries,
      show: ({ resourcesStore: {show} }) => show,
      modal: ({ modalStore: {modal} }) => modal,
      loading: ({ resourcesStore: {loading} }) => loading
    }),
  },
  methods: {
    toggleModal(type) {
      if (!this.$auth.loggedIn && type == 'favorite') {
        var alertObj = {};
        alertObj.type = 'info';
        alertObj.message = 'Je kan alleen favorieten toevoegen als je bent ingelogd.';
        return this.$store.commit('alertStore/setAlert', alertObj);  
      }
      this.$store.commit('modalStore/setModal', type)
    }
  }
};
